import React  from 'react';
import styles from './styles.module.css';
export default function Table({ data }) {
  return (
    <div className={styles.container}>
      {data.map((data, index) => {
        return (
          <>
            <div className={styles.subContainer}>
              <div className={styles.name}>{data.location}</div>
              <div className={styles.dateAndTime}>
                {data.date} <div className={styles.dot}></div> {data?.time}
              </div>
            </div>
            <div className={styles.divider} />
          </>
        );
      })}
    </div>
  );
}
